// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8b9b87cf","239":"2f6bb931","732":"91d0ca24"}[chunkId] + ".chunk.js";
};